import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { FormArray, FormGroup } from "@angular/forms";
import moment from "moment/moment";
import { InvoiceService } from "../../invoice.service";
import { ActivatedRoute, Router } from "@angular/router";
import { UtilsService } from "../../../../auth/service/utils.service";
import { takeUntil, tap } from "rxjs/operators";
import { Subject } from "rxjs";
import { utc } from "moment";

@Component({
  selector: 'app-credit-note-edit',
  templateUrl: './credit-note-edit.component.html'
})
export class CreditNoteEditComponent implements OnInit, OnDestroy {
  contentHeader: IContentHeader;
  creditNoteId: number;
  creditNote: any;
  invoiceForm: FormGroup;
  expireInDays: number = 30;
  showErrors = false;
  credit_note_types: any = [];
  customersList: any = [];
  filterYear: number = moment().year();
  years = Array.from({ length: this.filterYear - 2024 + 2 }, (v, i) => 2024 + i);
  document_codes: { id: number; name: string; other: { code: string } }[] = [];
  payment_measure_units: any = [];
  rows_types: any = [];
  payment_terms: any = [];
  invoice_services: any = [];
  clickedOnSave: boolean = true;
  rowsToManipulate: number[] = [];

  attachments_list = []

  private _unsubscribeAll: Subject<any> = new Subject();
  private defaultRowType: number | undefined;
  private defaultServiceTrack: any;

  constructor(
    public _invoiceService: InvoiceService,
    private cdr: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    public _utilsService: UtilsService
  ) {

    this.activatedRoute.params
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((params) => {
        if (!!params.id) {
          this.creditNoteId = params.id;
        }
      });

    this.contentHeader = {
      headerTitle: "EDIT_CREDIT_NOTE",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.INVOICES",
            isLink: false
          },
          {
            name: "MENU.INVOICES_GENERATED",
            isLink: true,
            link: "/dashboard/invoice/generated"
          },
          {
            name: "EDIT_CREDIT_NOTE",
            isLink: false
          }
        ]
      }
    };
  }

  async ngOnInit() {

    const itemsForLists = await this._invoiceService.itemsForLists();
    this.credit_note_types = itemsForLists.credit_note_types;
    this.document_codes = itemsForLists.document_codes;
    this.payment_measure_units = itemsForLists.payment_measure_units;
    this.rows_types = itemsForLists.rows_types;
    this.invoice_services = itemsForLists.invoice_services;
    this.payment_terms = itemsForLists.payment_terms;

    this.defaultRowType = this.rows_types.find((type: any) => !!type.other.default)?.id;
    this.defaultServiceTrack = this.invoice_services.find((service: any) => !!service.other.default) || {};

    this._invoiceService.get(this.creditNoteId)
      .pipe(
        takeUntil(this._unsubscribeAll),
        tap((creditNote) => {
          this.invoiceForm = this._invoiceService.buildForm(true);

          this.invoiceForm.get("invoice_order_number").setValidators(null);
          this.invoiceForm.get("invoice_order_number").updateValueAndValidity();

          this.creditNote = creditNote;
          return creditNote;
        })
      )
      .subscribe((creditNote => {
        const additional_data: any = this._invoiceService.explodeAdditionalData(creditNote.additional_data);

        this.invoiceForm.patchValue({
          client_id: creditNote.client.id,
          payment_terms: creditNote.payment_terms.id,
          invoice_type: creditNote.invoice_type.id,
          vat_code: creditNote.vat_code,
          has_client_approval: creditNote.has_client_approval,
          accrual_exercise: creditNote.accrual_exercise,
          document_code_id: creditNote.document_code_id,
          document_date: creditNote.document_date,
          expiration_date: creditNote.expiration_date,
          order_id: creditNote.order_id,
          order_product_id: creditNote.order_product_id,
          order_child_id: creditNote.order_child_id,
          invoice_order_number: additional_data.IdDocumento,
          order_number: additional_data.IdDocumento
        });

        creditNote.rows.forEach((row, index) => {
          const newRow = this._invoiceService.buildRow(index, row.row_type_id, row.service_track_id);

          newRow.patchValue({
            vat_code: row.vat_code,
            payment_measure_unit: row.payment_measure_unit_id,
            service_description: row.service_description,
            description: row.description,
            quantity: row.quantity,
            price: row.price,
            total_amount: row.row_total_amount,
          })

          this.rows.push(newRow);
        })


        this.calculateTotalAmount();

      }))
  }

  get rows() {
    return this.invoiceForm.controls.rows as FormArray;
  }

  fieldHasError(field: string) {
    return this._invoiceService.fieldHasError(this.invoiceForm, field, this.showErrors);
  }

  handlerChangePaymentTerms() {
    const paymentTerm: any = this.payment_terms.find((pt: any) => pt.id === this.invoiceForm.value.payment_terms);
    this.expireInDays = paymentTerm?.other?.day_value || 30;
    if (!this.invoiceForm.value.document_date) return;
    this.handlerChangeDocumentDate();
  }

  handlerChangeDocumentDate() {
    const date: moment.Moment = utc(this.invoiceForm.value.document_date);
    date.add(this.expireInDays/30, "months");
    const paymentTerm: any = this.payment_terms.find((pt: any) => pt.id === this.invoiceForm.value.payment_terms);
    if (paymentTerm && paymentTerm.other.payment_end_month) {
      date.endOf("month");
    }
    // aggiorno forzatamente input expiration_date
    setTimeout(() => {
      const boxExpireDate: any = document.querySelector("#expiration_date input");
      if (boxExpireDate) boxExpireDate.value = date.format("YYYY-MM-DD");
      this.invoiceForm.patchValue({ expiration_date: date.format("YYYY-MM-DD"), accrual_exercise: moment(this.invoiceForm.value.document_date).year() });
    });
    this.cdr.detectChanges();
  }

  ngOnDestroy() {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  selectAllToDelete() {
    this.rowsToManipulate = this.rows.controls.map((row) => row.value.id);
  }

  addRow() {
    const newRow = this._invoiceService.buildRow(this.rows.length + 1, this.defaultRowType, this.defaultServiceTrack.id);
    newRow.patchValue({ vat_code: this.defaultServiceTrack.other.sales_vat });
    this.rows.push(newRow);
    this._invoiceService.openLastRow();
  }

  removeRows() {
    if (!this.rowsToManipulate.length) return false;

    const controls = this.rows.controls;
    this.rowsToManipulate.map((row) => {
      const findIndex = controls.findIndex((row2: any) => Number(row2.value.id) === row);
      this.rows.removeAt(findIndex);
    });

    this.rowsToManipulate = [];

    if (!this.rows.length) {
      this.addRow();
    }

    this.calculateTotalAmount();
  }

  toggleSelectRow(index: number) {
    if (this.rowsToManipulate.includes(index)) {
      this.rowsToManipulate = this.rowsToManipulate.filter((item) => item !== index);
    } else {
      this.rowsToManipulate.push(index);
    }
  }

  calculateTotalAmount() {
    setTimeout(() => this.invoiceForm.patchValue({ total_amount: this._invoiceService.calculateTotalAmount(this.rows) }))
  }

  handlerAction(){
    this.showErrors = true;
    this.clickedOnSave = true;

    // controllo valori
    if (this.invoiceForm.invalid) {
      for (const key of Object.keys(this.invoiceForm.controls)) {
        if (key === "rows") continue;
        if (this.invoiceForm.controls[key].status !== "VALID") {
          console.warn(`${key} is invalid`);
          const input: any = document.querySelector(`*[formcontrolname="${key}"]`);
          if (input) {
            input?.scrollIntoView({ behavior: "smooth", block: "start" });
            input?.focus();
          }
        }
      }

      for (const key of Object.keys(this.rows.controls)) {
        if (this.rows.controls[key].status !== "VALID") {
          console.warn(`${key} is invalid`);
        }
      }
      this.clickedOnSave = false;
      return false;
    }

    const order_date_field = this.invoiceForm.value.order_date
    const order_date = order_date_field ? (order_date_field.includes('/') ? order_date_field : moment(order_date_field).format('DD/MM/YYYY')) : null;

    const values: any = {
      ...this.invoiceForm.value,
      isBlank: true,
      rows: this.invoiceForm.value.rows.filter((row: any) => row !== null),
      additional_data: `[DatiOrdineAcquisto|IdDocumento|${this.invoiceForm.value.invoice_order_number || 0}];[DatiOrdineAcquisto|Data|${order_date}]`,
      attachments: this.attachments_list || []
    };

    delete values.order_number;
    delete values.order_date;

    this.clickedOnSave = false;

    this._utilsService.showLoading();

    this._invoiceService.update(this.creditNoteId, values).subscribe((res: any) => {
      if (!!res && !res.error) {
        this.router.navigateByUrl("/dashboard/invoice/generated");
      }
    });
  }
}
